import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRCodeSection = ({ url, age }) => {
    // Default URL if none provided
    const qrUrl = url || 'https://www.aad.org/public/everyday-care/skin-care-basics/care/skin-care-for-teens';
    
    // Shorten URL for display (show domain + first path segment)
    const displayUrl = () => {
        try {
            const urlObj = new URL(qrUrl);
            const pathParts = urlObj.pathname.split('/').filter(Boolean);
            const shortPath = pathParts.length > 0 ? `/${pathParts[0]}...` : '';
            return `${urlObj.hostname}${shortPath}`;
        } catch {
            return qrUrl.substring(0, 30) + '...';
        }
    };

    return (
        <div className="qr-code-section">
            <div className="qr-code-container">
                <QRCodeCanvas 
                    value={qrUrl}
                    size={120}
                    level="M"
                    includeMargin={true}
                    imageSettings={{
                        src: "",
                        height: 24,
                        width: 24,
                        excavate: true,
                    }}
                />
            </div>
            <div className="qr-code-info">
                <h4 className="qr-title">🌱 청소년 피부 관리 가이드</h4>
                <p className="qr-subtitle">
                    QR코드를 스캔하여 나이({age}세)에 맞는<br/>
                    피부 관리 정보를 확인하세요
                </p>
                <p className="qr-url">{displayUrl()}</p>
                <p className="qr-note">
                    💡 부모님과 함께 확인하시면 더욱 좋습니다
                </p>
            </div>
        </div>
    );
};

export default QRCodeSection;